import { render, staticRenderFns } from "./relevance.vue?vue&type=template&id=d123fdb0"
import script from "./relevance.vue?vue&type=script&lang=js"
export * from "./relevance.vue?vue&type=script&lang=js"
import style0 from "./relevance.vue?vue&type=style&index=0&id=d123fdb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports